import { masks } from '@/lib/utils'

interface Props {
  value: string
  hasDdi?: boolean
  showDdi?: boolean
}

function PhoneNumberField({ value, hasDdi = true, showDdi = false }: Props) {
  if (!value) return null

  let regex = masks.regex.phoneNumber
  if (hasDdi) regex = masks.regex.phoneNumberWithDdi

  const withDdi = hasDdi && showDdi

  return value.replace(
    regex,
    (all, n1, n2, n3) => `${withDdi ? `+${n1} ` : ''}(${withDdi ? n2 : n1}) ${withDdi ? n3 : n2}`
  )
}

export default PhoneNumberField
